// React Fast Refresh preamble – injected before any React module loads in dev.
// Kept outside of src/routes/ to avoid the TanStack Router code-splitter
// misidentifying the import string as an ES module import statement.
export const reactRefreshPreamble = [
  "import RefreshRuntime from '/@react-refresh'",
  'RefreshRuntime.injectIntoGlobalHook(window)',
  'window.$RefreshReg$ = () => {}',
  'window.$RefreshSig$ = () => (type) => type',
  'window.__vite_plugin_react_preamble_installed__ = true',
].join('\n')
